import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicabshire() {



  const cardData =
  {
    keyword: 'Pune to Shirdi Cabs Hire',
    heading: 'Sai Trupti Cabs: Pune to Shirdi Cabs Hire',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Shirdi cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles—all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Shirdi. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Shirdi convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Shirdi with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "Sai Baba Samadhi Mandir is the spiritual epicenter of Shirdi and one of India’s most revered pilgrimage sites. Built entirely in white marble, it houses the holy resting place of Shri Sai Baba, whose teachings of love, equality, and compassion continue to inspire millions. Devotees gather here daily for aarti, darshan, and meditation, enveloped in a divine atmosphere of peace and devotion. The temple glows beautifully at night with lamps and chants filling the air. Managed by the Shri Saibaba Sansthan Trust, the complex includes halls, gardens, and facilities that ensure a seamless spiritual experience for every pilgrim."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai Mosque holds immense significance as the sacred place where Sai Baba spent more than 60 years of his life. This humble mosque, with its eternal flame (dhuni), symbolizes hope, healing, and divine grace. Devotees believe the sacred ash (udi) from the dhuni has miraculous powers to cure ailments and remove sorrow. The mosque’s simple stone walls echo with the saint’s compassion and humility. Visitors can see Baba’s brick seat, oil lamps, and photographs that capture his serene presence. Dwarkamai is not just a religious site — it’s the living heart of Baba’s message of faith and patience."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the sacred resting place where Sai Baba used to spend every alternate night during the later years of his life. The site still preserves Baba’s wooden bed, palkhi, and personal belongings, evoking his divine presence. Every Thursday, a grand palkhi procession begins from Dwarkamai to Chavadi with devotees chanting bhajans and carrying Sai Baba’s portrait in a beautifully decorated palanquin. The ritual symbolizes Baba’s eternal journey of guiding and blessing humanity. With its serene simplicity and deep devotion, Chavadi is a sacred corner that connects every visitor directly to Sai Baba’s soul."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning 'seat of the Guru,' is the exact spot where Sai Baba was first seen as a young ascetic meditating under a neem tree. Today, a small shrine with a marble statue of Baba and a sacred Shivling marks the place. Pilgrims light incense sticks and offer prayers, believing that worship here fulfills sincere wishes. The neem tree’s roots are believed to have curative properties, and its shade adds to the peaceful energy of the site. Gurusthan beautifully symbolizes the union of devotion, discipline, and enlightenment — a place where every soul finds its spiritual teacher."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a lush garden that Sai Baba personally nurtured and visited daily to meditate, plant trees, and light a lamp near the neem tree. The lamp, still burning today, is said to carry Baba’s eternal blessings. The garden’s serene pathways, blooming flowers, and cool air make it a peaceful refuge for reflection and prayer. Walking through Lendi Baug, devotees feel a deep sense of calm and connection with nature. It stands as a reminder that spirituality thrives in simplicity, service, and a harmonious relationship with the earth."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple marks the place where Sai Baba first set foot in Shirdi. When he arrived, the temple priest Mhalsapati greeted him with the words ‘Ya Sai!’ — giving him the name the world reveres today. Dedicated to Lord Khandoba, this small but historically significant shrine holds a deep connection to Sai Baba’s arrival and acceptance in Shirdi. The temple’s peaceful aura and humble architecture welcome pilgrims seeking to relive that divine moment of meeting between saint and devotee. Khandoba Temple beautifully preserves the spiritual genesis of Sai Baba’s journey in Shirdi."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a unique open-air museum that visually recreates the life and miracles of Sai Baba through realistic sculptures and life-sized scenes. Spread across scenic green landscapes, it blends art, devotion, and storytelling to make the saint’s teachings accessible to all. Families especially enjoy walking through exhibits that depict moments from Baba’s daily life and his compassion for the poor and needy. The park also features a small amusement area for children and a café for visitors. It’s a place where faith meets culture in an engaging, educational, and heartwarming way."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Located near the Sai Baba Temple, Wet N Joy Water Park offers fun and relaxation for families visiting Shirdi. Spread across 10 acres, it features thrilling water slides, a wave pool, lazy river, and dedicated kids’ zone. After a peaceful temple visit, visitors unwind here amidst laughter and excitement. The park’s cleanliness, safety standards, and vibrant environment make it a popular choice for tourists. With its joyful spirit, Wet N Joy complements Shirdi’s divine energy with recreation and rejuvenation — making it a wholesome travel destination for all age groups."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Situated within the Sai Baba Temple complex, Dixit Wada Museum preserves Sai Baba’s personal belongings, including his robes, footwear, utensils, and photographs. These humble artifacts tell stories of his simple yet profound life. Visitors can see his wooden stick, gramophone, and other items that evoke a sense of closeness to the saint. The museum also displays early photographs capturing Baba’s expressions of compassion and wisdom. Walking through Dixit Wada feels like stepping into Baba’s world — where simplicity, humility, and divine purpose merge beautifully."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Just 70 kilometers from Shirdi lies the famous Shani Shingnapur Temple, dedicated to Lord Shani, the deity of justice. The temple is unique for its open-air design — there are no doors or locks in the entire village, as residents believe Lord Shani protects them from harm. Devotees from across India visit to seek blessings and relief from life’s hardships. The aura of faith and fearlessness here is truly inspiring. Pilgrims often combine their Shirdi trip with a visit to Shani Shingnapur, completing a spiritually enriching and transformative journey."
  }
],



"services": [
  {
    "name": "Pune to Shirdi Cabs Hire",
    "description": "Book Pune to Shirdi cabs for a peaceful and comfortable journey to the famous Sai Baba Temple. Enjoy clean and well-maintained vehicles, AC/non-AC options, professional drivers, luggage support, and flexible pickup/drop timings. Perfect for pilgrims, families, and groups seeking reliable travel between Pune and Shirdi."
  },
  {
    "name": "Pune to Shirdi Taxi Service",
    "description": "Reliable Pune to Shirdi taxi service offering professional chauffeurs, AC/non-AC options, and comfortable vehicles for a smooth 4-5 hour journey. Ideal for Sai devotees and tourists, ensuring punctual service and safe rides with affordable pricing."
  },
  {
    "name": "Pune to Shirdi Car Hire",
    "description": "Hire a private car from Pune to Shirdi for a customized travel experience. Choose from Sedans, SUVs, and luxury cars equipped with AC/non-AC options, experienced drivers, and spacious interiors for a stress-free spiritual or leisure trip."
  },
  {
    "name": "Pune to Shirdi AC Cab",
    "description": "Travel comfortably from Pune to Shirdi in air-conditioned cabs with professional drivers, spacious seating, and flexible pickup/drop schedules. Experience a cool, comfortable, and safe journey perfect for family and temple visits."
  },
  {
    "name": "Pune to Shirdi Non AC Cab",
    "description": "Economical non-AC cab service from Pune to Shirdi offering reliable vehicles, professional drivers, and flexible timings. Great for budget-conscious travelers seeking a smooth and efficient temple visit."
  },
  {
    "name": "Luxury Cab Pune to Shirdi",
    "description": "Experience comfort and elegance with luxury cabs from Pune to Shirdi featuring premium interiors, AC comfort, and professional chauffeurs. Ideal for business executives, VIP guests, and wedding travel seeking first-class service."
  },
  {
    "name": "Pune to Shirdi Innova Cab",
    "description": "Spacious Innova cabs from Pune to Shirdi with AC/non-AC options, experienced drivers, and ample luggage space. Perfect for family groups, corporate teams, and devotees traveling together for comfortable and safe long-distance rides."
  },
  {
    "name": "Pune to Shirdi Ertiga Cab",
    "description": "Affordable and comfortable Ertiga cab service from Pune to Shirdi offering AC/non-AC options, professional drivers, flexible timings, and spacious interiors. Ideal for small families or friend groups heading for a temple visit."
  },
  {
    "name": "Affordable Pune to Shirdi Cab",
    "description": "Budget-friendly Pune to Shirdi cab services offering transparent fares, AC/non-AC options, reliable vehicles, and professional chauffeurs. Ensures an economical yet comfortable travel experience for pilgrims and families."
  },
  {
    "name": "Pune to Shirdi Outstation Cab",
    "description": "Book outstation cabs from Pune to Shirdi for convenient travel with AC/non-AC options, experienced drivers, flexible return options, and online booking support. Perfect for weekend religious trips or short family vacations."
  },
  {
    "name": "Pune to Shirdi One Way Cab",
    "description": "One-way cab service from Pune to Shirdi providing affordable fares, AC/non-AC options, and professional drivers. Ideal for travelers visiting Shirdi without needing a return journey, ensuring convenience and cost efficiency."
  },
  {
    "name": "Pune to Shirdi Drop Cab",
    "description": "Book Pune to Shirdi drop cabs for a comfortable and punctual one-way transfer. Includes AC/non-AC options, professional chauffeurs, luggage assistance, and flexible pickup locations across Pune city."
  },
  {
    "name": "Pune to Shirdi Corporate Cab",
    "description": "Corporate cab hire service from Pune to Shirdi offering professional chauffeurs, AC/non-AC premium cars, flexible schedules, and smooth rides. Perfect for corporate retreats, business travel, or team pilgrimages."
  },
  {
    "name": "Pune to Shirdi Wedding Cab",
    "description": "Elegant wedding cab service from Pune to Shirdi featuring luxury vehicles, AC comfort, skilled chauffeurs, and punctual pickups. Designed for wedding guests, family members, and event logistics with reliable service."
  },
  {
    "name": "Pune to Shirdi Online Booking",
    "description": "Book your Pune to Shirdi cab online in just a few clicks. Choose from AC/non-AC options, Sedans, SUVs, and luxury cars with instant confirmation, secure payment, professional drivers, and flexible pickup/drop schedules."
  }
],
"tableData": [
  ["Pune to Shirdi Cabs Hire", "Pune to Shirdi Taxi Service"],
  ["Pune to Shirdi Car Hire", "Pune to Shirdi AC Cab"],
  ["Pune to Shirdi Non AC Cab", "Luxury Cab Pune to Shirdi"],
  ["Pune to Shirdi Innova Cab", "Pune to Shirdi Ertiga Cab"],
  ["Affordable Pune to Shirdi Cab", "Pune to Shirdi Outstation Cab"],
  ["Pune to Shirdi One Way Cab", "Pune to Shirdi Drop Cab"],
  ["Pune to Shirdi Corporate Cab", "Pune to Shirdi Wedding Cab"],
  ["Pune to Shirdi Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Shirdi Cabs Hire",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Shirdi — perfect for pilgrimage trips, family travel, or leisure road trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Shirdi cabs, starting at approx. ₹2,100–₹2,500 for sedans, depending on vehicle type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Pune–Shirdi route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Shirdi route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at Shirdi town, railway station, or temple vicinity."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for the longer drive from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Shirdi cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]
























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Shirdi cab hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Shirdi cab hire services for one way, round trips, and group travel to the holy shrine of Shirdi Sai Baba.',
  },
  {
    question: 'How can I hire a cab from Pune to Shirdi with Sai Trupti Cabs?',
    answer: 'You can easily hire a cab from Pune to Shirdi through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What cab options are available for Pune to Shirdi hire?',
    answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to match your comfort, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for the Pune to Shirdi route?',
    answer: 'Yes, all our drivers are professional, courteous, and well-experienced in long-distance travel, ensuring a safe and comfortable journey from Pune to Shirdi.',
  },
  {
    question: 'Can I book Pune to Shirdi cabs for family, group, or temple visits?',
    answer: 'Certainly. Our Pune to Shirdi cab hire service is ideal for family trips, temple darshan tours, corporate visits, and group pilgrimages.',
  },
  {
    question: 'Is the Pune to Shirdi cab hire service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab hire services between Pune and Shirdi for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Shirdi cab hire fares?',
    answer: 'Our Pune to Shirdi cab fares start from approximately ₹2,200 for sedans and ₹2,800–₹3,800 for SUVs and premium vehicles, depending on your travel type and cab model.',
  },
  {
    question: 'What payment methods are available for Pune to Shirdi cab hire?',
    answer: 'We accept payments through UPI, credit/debit cards, bank transfers, and digital wallets for a smooth and secure booking experience.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Shirdi cabs?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety standards to ensure a comfortable and safe journey.',
  },
  {
    question: 'Is customer support available during my Pune to Shirdi cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Shirdi trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Deshmukh',
    feedback: 'I hired a Pune to Shirdi cab with Sai Trupti Cabs. The experience was smooth and comfortable. The driver was polite and on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Bhosale',
    feedback: 'Sai Trupti Cabs provided excellent Pune to Shirdi cab hire service. The ride was clean, affordable, and perfectly managed.',
    rating: 5,
  },
];




















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cabs Hire",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book cabs from Pune to Shirdi for pilgrimages, weddings, or corporate trips. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-shirdi-cabs-hire"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Shirdi Cabs Hire | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Shirdi for pilgrimages, weddings, or corporate trips. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Shirdi Cabs Hire, Pune to Shirdi Taxi Service, Pune to Shirdi Car Hire, Pune to Shirdi AC Cab, Pune to Shirdi Non AC Cab, Luxury Cab Pune to Shirdi, Pune to Shirdi Innova Cab, Pune to Shirdi Ertiga Cab, Affordable Pune to Shirdi Cab, Pune to Shirdi Outstation Cab, Pune to Shirdi One Way Cab, Pune to Shirdi Drop Cab, Pune to Shirdi Corporate Cab, Pune to Shirdi Wedding Cab, Pune to Shirdi Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicabshire;